'use strict';

const getPackageType = require('./async.cjs');
const getPackageTypeSync = require('./sync.cjs');

module.exports = filename => getPackageType(filename);
module.exports.sync = getPackageTypeSync;
